
export default [
    {
      path:'/login',
      name: 'login',
      title: '登录',
      component: () => import(/* webpackChunkName: "constRoutes" */ '../../views/login')
    },
    
]